// GlobalMixin.ts
import { Component, Vue } from 'vue-facing-decorator'

@Component
export default class GlobalMixin extends Vue {
  get isPC(): boolean {
    // using client width to determine display UI is for PC or SP
    return document.documentElement.clientWidth >= 1200
  }

  self<T>(this: T) {
    return this as T
  }
}
